"use strict";

function callModal(dataModal) {

  var modalDiv = $('#js-message');
  modalDiv.find('.modal-title').html(dataModal['header']);
  modalDiv.find('.modal-body').html(dataModal['body']);
  modalDiv.find('.modal-footer').html(dataModal['footer']);
  modalDiv.modal();
}

function scrollWindow(id, speed) {
  var page = $("html, body");

  var header = 0;

  page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function () {
    page.stop();
  });

  page.animate({scrollTop: $(id).offset().top - header}, speed, function () {
    page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
  });
}


function toggleMenu(targetBtn, targetMenu){
  var 
  isMenuOpen,
  isBtnOpen;

  isBtnOpen = targetBtn.data('is-open');
  isMenuOpen = targetMenu.data('is-open');

  if (!isMenuOpen && !isBtnOpen) {
    targetMenu.addClass('menu--is-open');
    targetBtn.addClass('btn-menu--is-open');

    targetBtn.data('is-open', 1);
    targetMenu.data('is-open', 1);

  } else {
    targetMenu.removeClass('menu--is-open');
    targetBtn.removeClass('btn-menu--is-open');

    targetBtn.data('is-open', 0);
    targetMenu.data('is-open', 0);
  }          
}


function findBigHeight(id){

  var eventHeight = [];
  $(id).each(function(index, el) {
    eventHeight.push(parseInt($(el).height())); 

  });
  eventHeight = eventHeight.sort(function(a, b){return b-a;});
  return eventHeight[0];

}


$(function() {
  $('.js-map').click(function() {
    $(this).find('iframe').toggleClass('scroll-off');
  });
  $('.js-map').on("mouseleave", function() {

    $(this).find('iframe').addClass('scroll-off');
  });
});


$(function() {
  $(document).on('click', '#__bs_notify__', function(event) {
    event.preventDefault();
    $(this).remove(); /* Act on the event */
  }); 
});

$(function() {
  var d = new Date();
  $('.js-actual-year').append(d.getFullYear());
});


function detectIE() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    /* IE 10 or older => return version number*/
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    /* IE 11 => return version number */
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }
  /* other browser */
  return false;
}